module.exports = __webpack_public_path__ + "img/cookies.9e058abb.png";